import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/area',
    },
    {
        path: '/area',
        name: 'Area',
        component: () => import('../views/Area.vue')
    },
    {
        path: '/device',
        name: 'Device',
        component: () => import('../views/Device.vue')
    },
    {
        path: '/setting',
        name: 'Setting',
        component: () => import('../views/Setting.vue')
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
